const productIdTranslationTable = {
  823: 'wateringCan',
  463: 'bigDrill',
  116: 'hood',
  1: 'bathTub',
  673: 'faucetWater',
  4203: 'animal',
  205: 'flash',
  173: 'lamp',
  323: 'brush',
  585: 'screw',
  3943: 'wall',
  4605: 'armchair',
};

export default id =>
  productIdTranslationTable[id] ? productIdTranslationTable[id] : 'armchair';
